import EmployeeShortProfile from "../employeeShortProfile/EmployeeShortProfile";
import "./SubHeaderLinks.css";
import { getSessionItem } from "../../utils/helper/session";

function SubHeaderLinks() {
  const user = getSessionItem('User')

  return (
    <div className="profile-subheader">
      <EmployeeShortProfile
        employeeName={user.firstName + ' ' + user.lastName}
        employeePronoun={user.pronoun}
        employeeDesignation={user.jobDescription}
        employeeID={user.id}
        employeeUsername={user.email}
        employeeLocation={user.city}
        employeeDepartment={user.department}
        employeeIdvStatus={getSessionItem("trolleyIdvStatus")}
      />
    </div>
  );
}

export default SubHeaderLinks;
